import { Button, ComponentStyle} from '@/imports-files/components/confirmation-modal';
import { sendOfferToCandidate } from '@/imports-files/pages/clients/candidates/kanban';
import Modal from "@/components/common-modal/modal";

export function SendOfferModal({setBtnPopup, sendOfferPopup, heightClass, setInitialData})
{

  return(
          <Modal
            type="confirmation"
            className={`CandidateFilterModal`}
            noCloseIcon={true}
            message="Congratulations!! You have received all the required approvals for this offer. Its time to send it to the candidate."
            texts={{
              button1_text: 'Cancel',
              button2_text: 'Send Offer',
            }}
            closeModal={() => setBtnPopup(false)}
            btnAction={async() => {
                      await sendOfferToCandidate({id: sendOfferPopup.offer_id, from: 'application_view', kanban: {candidate_index: props.candidateIndex, base_stage_id: props.paramStageId}}, setBtnPopup, setInitialData)
                    }}
          />
        )
} 

